export * from "./opening-hours1";
